const CRISP_WEBSITE_ID = '4bae9da9-1beb-450c-99b4-cff9365ed8ff'
const CRISP_SCRIPT_SRC = 'https://client.crisp.chat/l.js'

let isCrispInitialized = false
let areCrispEventsBound = false

const canUseCrisp = () => typeof window !== 'undefined' && typeof document !== 'undefined'

const ensureCrispQueue = () => {
  window.$crisp = window.$crisp || []
  return window.$crisp
}

const loadCrispScript = () => {
  const existingScript = document.querySelector('script[data-crisp-loader="true"]')
  if (existingScript) {
    return
  }

  const script = document.createElement('script')
  script.src = CRISP_SCRIPT_SRC
  script.async = true
  script.dataset.crispLoader = 'true'
  document.head.appendChild(script)
}

const bindCrispEvents = () => {
  if (areCrispEventsBound) {
    return
  }

  const crisp = ensureCrispQueue()

  // После ручного закрытия снова скрываем дефолтный виджет Crisp
  crisp.push(['on', 'chat:closed', () => {
    ensureCrispQueue().push(['do', 'chat:hide'])
  }])

  areCrispEventsBound = true
}

export const initCrispSupport = () => {
  if (!canUseCrisp() || isCrispInitialized) {
    return
  }

  const crisp = ensureCrispQueue()
  window.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID
  crisp.push(['do', 'chat:hide'])

  bindCrispEvents()
  loadCrispScript()
  isCrispInitialized = true
}

export const setCrispPlayerId = (playerId) => {
  if (!canUseCrisp() || !playerId) {
    return
  }

  initCrispSupport()

  // Передаем ID игрока в данные сессии, чтобы саппорт видел его в чате
  ensureCrispQueue().push(['set', 'session:data', [[['player_id', String(playerId)]]]])
}

export const openCrispSupport = (playerId = null) => {
  if (!canUseCrisp()) {
    return
  }

  initCrispSupport()

  const crisp = ensureCrispQueue()

  if (playerId) {
    crisp.push(['set', 'session:data', [[['player_id', String(playerId)]]]])
  }

  crisp.push(['do', 'chat:show'])
  crisp.push(['do', 'chat:open'])
}

export const closeCrispSupport = () => {
  if (!canUseCrisp()) {
    return
  }

  const crisp = ensureCrispQueue()
  crisp.push(['do', 'chat:close'])
  crisp.push(['do', 'chat:hide'])
}

export const resetCrispSession = () => {
  if (!canUseCrisp()) {
    return
  }

  const crisp = ensureCrispQueue()

  crisp.push(['set', 'session:data', [[['player_id', '']]]])
  crisp.push(['do', 'session:reset'])
  crisp.push(['do', 'chat:hide'])
}
